import "./App.less";
import React, { useEffect, useState, useCallback } from "react";
import { InspectionType } from "./utils/enums";
import { getBOLSummary } from "./api";
import BOL from "./components/BOL/BOL";
import HeaderBar from "./components/HeaderBar/HeaderBar";
import Loading from "./components/Loading/Loading";
import Error from "./components/Error/Error";
// import BolImagePreview from "./components/BOL/BolImagePreview";

// Main app component, fetches the vehicle data to create the BOL and returns a HeaderBar component and a BOL component to create the page.
// Handles displaying a placeholder loading page and error page if an error happens getting the vehicle data, handled by Loading and Error components respectively.

const App = () => {
  const [vehicleData, setVehicleData] = useState(null);
  const [inspectionType, setInspectionType] = useState(InspectionType.Pickup);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isHistorical, setIsHistorical] = useState(false);
  const [showBOL, setShowBOL] = useState(true);
  // const [imageVersion, setImageVersion] = useState(0);
  const [, setImageVersion] = useState(0);

  const fetchData = useCallback(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const vehicleId = urlParams.get("vehicleId");
    const bolId = urlParams.get("bolId");
    const code = urlParams.get("code");

    const hasVehicleId =
      vehicleId !== null && vehicleId !== undefined && vehicleId !== "";
    setIsHistorical(!hasVehicleId);

    const vehicleInfo = await getBOLSummary(vehicleId, bolId, code);

    const hasPickup = vehicleInfo.some(
      inspection => inspection.type === InspectionType.Pickup,
    );
    const hasDropOff = vehicleInfo.some(
      inspection => inspection.type === InspectionType.DropOff,
    );

    if (!Array.isArray(vehicleInfo) || vehicleInfo?.length === 0) {
      // Could not find vehicle data, set error
      setError(true);
      setVehicleData(null);
    } else {
      // Vehicle data retrieved, set state to render document
      setVehicleData(vehicleInfo);
      setError(false);
    }

    setInspectionType(() => {
      if (hasPickup) {
        return InspectionType.Pickup;
      }

      if (hasDropOff) {
        return InspectionType.DropOff;
      }

      return InspectionType.Pickup;
    });

    setLoading(false);
  }, []);

  // Fetch vehicle data for BOL. App looks for a vehicleId in the params to send the request to the api.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const inspectionType = urlParams.get("inspectionType");
    setInspectionType(
      inspectionType === "dropoff"
        ? InspectionType.DropOff
        : InspectionType.Pickup,
    );

    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setShowBOL(true);
    setImageVersion(prev => prev + 1);
  }, [inspectionType]);

  if (error) {
    return <Error />;
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <HeaderBar
        inspectionType={inspectionType}
        setInspectionType={setInspectionType}
        vehicleData={vehicleData}
      />
      {showBOL && (
        <div id="bol-to-capture">
          <BOL
            inspectionType={inspectionType}
            vehicleData={vehicleData}
            isHistorical={isHistorical}
          />
        </div>
      )}

      {/* <BolImagePreview
        targetId="bol-to-capture"
        imageVersion={imageVersion} // change to re-trigger generation
        onImageReady={() => setShowBOL(false)}
      /> */}
    </>
  );
};

export default App;
